import { render, staticRenderFns } from "./HotpPicText.vue?vue&type=template&id=3a833b5a&scoped=true"
import script from "./HotpPicText.vue?vue&type=script&lang=js"
export * from "./HotpPicText.vue?vue&type=script&lang=js"
import style0 from "./HotpPicText.vue?vue&type=style&index=0&id=3a833b5a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a833b5a",
  null
  
)

export default component.exports